@if (alert(); as a) {
  <div
    class="ab"
    role="status"
  >
    <svg
      class="ab-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="9"
        r="5"
      ></circle>
      <path d="M9 13.5L7.5 21l4.5-2.5 4.5 2.5L15 13.5"></path>
    </svg>
    <p class="ab-text">
      <b class="ab-title">{{ a.title }}</b>
      @if (a.description) {
        <!-- &ngsp; keeps the spaces, so screen readers don't run the title into the text. -->
        &ngsp;<span
          class="ab-sep"
          aria-hidden="true"
          >·</span
        >&ngsp;<span>{{ a.description }}</span>
      }
    </p>
    @if (linkLabelKey() && link()) {
      <a
        class="ab-link"
        [routerLink]="link()"
        >{{ linkLabelKey() | translate }}</a
      >
    }
    <button
      type="button"
      class="ab-close"
      [attr.aria-label]="'alertBannerDismiss' | translate"
      [matTooltip]="'alertBannerDismiss' | translate"
      (click)="dismiss(a)"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M6 6l12 12M18 6L6 18"></path>
      </svg>
    </button>
  </div>
}
